import { render, staticRenderFns } from "./wl.vue?vue&type=template&id=5568a7be&scoped=true&"
import script from "./wl.vue?vue&type=script&lang=js&"
export * from "./wl.vue?vue&type=script&lang=js&"
import style0 from "./wl.vue?vue&type=style&index=0&id=5568a7be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568a7be",
  null
  
)

export default component.exports